<div class="op-modal--portal ngdialog-theme-openproject">
  <div class="op-modal--modal-container_new confirm-dialog--modal loading-indicator--location"
       data-indicator-name="modal"
       tabindex="0">
    <div class="op-modal--modal-header_new">
      <a class="op-modal--modal-close-button_new">
        <i
            class="icon-close"
            (click)="closeMe($event)"
            [attr.title]="text.close_popup">
        </i>
      </a>
      <h3 class="op-modal-title" [textContent]="text.title"></h3>
    </div>

    <div class="ngdialog-body op-modal--modal-body">
      <div *ngFor="let widget of selectable;trackBy: trackWidgetBy"
           (click)="select($event, widget)"
           [id]="widget.identifier"
           [textContent]="widget.title"
           class="grid--addable-widget" >
      </div>

      <!-- <enterprise-banner *ngIf="eeShowBanners"
                         [linkMessage]="text.upsale_link"
                         [textMessage]="text.upsale_text"
                         class="grid--add-widget-ee"
                         opReferrer="grids#add-widget">
      </enterprise-banner> -->
    </div>
  </div>
</div>
